import ApiClient from './ApiClient';

class CampaignSegmentsAPI extends ApiClient {
  constructor() {
    super('campaign_segments', { accountScoped: true });
  }
}

export default new CampaignSegmentsAPI();
